export const AUTO_MEASURE_TYPES = {
    FLOOR_AREAS: 'FLOOR_AREAS',
    PERIMETER: 'PERIMETER',
} as const;

export type AutoMeasureType = keyof typeof AUTO_MEASURE_TYPES;
